module.exports = __webpack_public_path__ + "img/Frame8701@2x.e239edc2.png";